import {
  deleteData,
  getData,
  patchFormData,
  patchRawData,
  postFormData,
  postRawData,
} from "./index";

export const getCommunicationTemplates = async (payload) => {
  return getData("communication-templates", payload).then((data) => {
    return data;
  });
};

export const getCommunicationTemplateById = async (id, payload) => {
  return getData(`communication-templates/${id}`, payload).then((data) => {
    return data;
  });
};

export const createCommunicationTemplate = async (payload) => {
  return postRawData("communication-templates", payload).then((data) => {
    return data;
  });
};

export const updateCommunicationTemplate = async (id, payload) => {
  return patchRawData(`communication-templates/${id}`, payload).then((data) => {
    return data;
  });
};

export const deleteCommunicationTemplate = async (id, payload) => {
  return deleteData(`communication-templates/${id}`, payload).then((data) => {
    return data;
  });
};

export const sendCommunication = async (payload) => {
  return postRawData("communication-templates/send", payload).then((data) => {
    return data;
  });
};

export const getCommunicationHistory = async (payload) => {
  return getData("communication-templates/history", payload).then((data) => {
    return data;
  });
};

export const getCommunicationHistoryGroups = async (payload) => {
  return getData("communication-templates/history/groups", payload).then((data) => {
    return data;
  });
};

export const getCommunicationHistoryByGroup = async (groupId, payload) => {
  return getData(`communication-templates/history/group/${groupId}`, payload).then((data) => {
    return data;
  });
};
